(() => {
  const ZOOM_ACTIVE_CLASS = 'Product--zoom-active';
  const DESKTOP_BREAKPOINT = 1008;

  let isZoomActive = false;
  let savedScrollY = 0;
  let scrollObserver = null;

  /* ── Pinch-to-zoom state (mobile) ── */
  const pinch = {
    active: false,
    initialDist: 0,
    initialScale: 1,
    scale: 1,
    translateX: 0,
    translateY: 0,
    originX: '50%',
    originY: '0',
    panStartX: 0,
    panStartY: 0,
    initialTranslateX: 0,
    initialTranslateY: 0,
    target: null,
    gallery: null,
    didInteract: false
  };

  function getPinchDist(t1, t2) {
    const dx = t1.clientX - t2.clientX;
    const dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getPinchMidpoint(t1, t2) {
    return {
      x: (t1.clientX + t2.clientX) / 2,
      y: (t1.clientY + t2.clientY) / 2
    };
  }

  function clampTranslate() {
    if (!pinch.target || !pinch.gallery || pinch.scale <= 1) return;
    var s = pinch.scale;
    var targetW = pinch.target.offsetWidth;
    var targetH = pinch.target.offsetHeight;
    var viewW = pinch.gallery.offsetWidth;
    var viewH = pinch.gallery.offsetHeight;
    // Horizontal: don't let edges scroll past viewport
    var maxX = (targetW * s - viewW) / (2 * s);
    if (maxX < 0) maxX = 0;
    pinch.translateX = Math.max(-maxX, Math.min(maxX, pinch.translateX));
    // Vertical: don't let edges scroll past viewport
    var maxY = (targetH * s - viewH) / (2 * s);
    if (maxY < 0) maxY = 0;
    pinch.translateY = Math.max(-maxY, Math.min(maxY, pinch.translateY));
  }

  function applyPinchTransform() {
    if (!pinch.target) return;
    pinch.target.style.transformOrigin = pinch.originX + ' ' + pinch.originY;
    pinch.target.style.transform =
      'scale(' + pinch.scale + ') translate(' + pinch.translateX + 'px, ' + pinch.translateY + 'px)';
  }

  function resetAllPinchZoom(wrapper) {
    var slideshow = wrapper.querySelector('.Product__Slideshow');
    if (slideshow) {
      slideshow.style.transform = '';
      slideshow.style.transformOrigin = '';
    }
    pinch.scale = 1;
    pinch.translateX = 0;
    pinch.translateY = 0;
    pinch.target = null;
    pinch.gallery = null;
    pinch.active = false;
    pinch.didInteract = false;
  }

  function setupPinchZoom(wrapper) {
    var gallery = wrapper.querySelector('.Product__Gallery');
    if (!gallery) return;

    gallery.addEventListener('touchstart', function(e) {
      if (!isZoomActive || window.innerWidth >= DESKTOP_BREAKPOINT) return;

      var slideshow = wrapper.querySelector('.Product__Slideshow');
      if (!slideshow) return;

      if (e.touches.length === 2) {
        e.preventDefault();
        pinch.active = true;
        pinch.didInteract = true;
        pinch.target = slideshow;
        pinch.gallery = gallery;
        pinch.initialDist = getPinchDist(e.touches[0], e.touches[1]);
        pinch.initialScale = pinch.scale;
        pinch.initialTranslateX = pinch.translateX;

        // Set transform origin to pinch midpoint relative to slideshow
        if (pinch.scale <= 1) {
          var mid = getPinchMidpoint(e.touches[0], e.touches[1]);
          var rect = slideshow.getBoundingClientRect();
          pinch.originX = ((mid.x - rect.left) / rect.width * 100) + '%';
          // Use the Y position relative to the gallery scroll + viewport
          var scrollTop = gallery.scrollTop;
          var galleryRect = gallery.getBoundingClientRect();
          var yInSlideshow = mid.y - galleryRect.top + scrollTop;
          pinch.originY = yInSlideshow + 'px';
        }
      } else if (e.touches.length === 1 && pinch.scale > 1) {
        e.preventDefault();
        pinch.didInteract = true;
        pinch.target = slideshow;
        pinch.gallery = gallery;
        pinch.panStartX = e.touches[0].clientX;
        pinch.panStartY = e.touches[0].clientY;
        pinch.initialTranslateX = pinch.translateX;
        pinch.initialTranslateY = pinch.translateY;
      }
    }, { passive: false });

    gallery.addEventListener('touchmove', function(e) {
      if (!isZoomActive || window.innerWidth >= DESKTOP_BREAKPOINT) return;
      if (!pinch.target) return;

      if (e.touches.length === 2 && pinch.active) {
        e.preventDefault();
        var dist = getPinchDist(e.touches[0], e.touches[1]);
        var newScale = Math.min(4, Math.max(1, pinch.initialScale * (dist / pinch.initialDist)));
        pinch.scale = newScale;
        if (newScale <= 1) {
          pinch.translateX = 0;
        }
        clampTranslate();
        applyPinchTransform();
      } else if (e.touches.length === 1 && pinch.scale > 1) {
        e.preventDefault();
        pinch.translateX = pinch.initialTranslateX + (e.touches[0].clientX - pinch.panStartX) / pinch.scale;
        pinch.translateY = pinch.initialTranslateY + (e.touches[0].clientY - pinch.panStartY) / pinch.scale;
        clampTranslate();
        applyPinchTransform();
      }
    }, { passive: false });

    gallery.addEventListener('touchend', function(e) {
      if (!isZoomActive || window.innerWidth >= DESKTOP_BREAKPOINT) return;
      pinch.active = false;
      if (pinch.scale <= 1.05) {
        resetAllPinchZoom(wrapper);
      }
    }, { passive: true });
  }

  function setZoomVisibleSlide(zoomImages, zoomThumbnails, mediaId) {
    zoomImages.forEach(el => {
      el.classList.toggle('is-zoom-visible', el.dataset.mediaId === mediaId);
    });
    zoomThumbnails.forEach(t => {
      t.classList.toggle('is-selected', t.dataset.mediaId === mediaId);
    });
  }

  /** Instant scroll (no smooth) so thumbnail changes dissolve via opacity, not motion */
  function scrollZoomGalleryToImage(zoomGallery, imageRow) {
    const gTop = zoomGallery.getBoundingClientRect().top;
    const tTop = imageRow.getBoundingClientRect().top;
    zoomGallery.scrollTop += tTop - gTop;
  }

  function setupScrollObserver(wrapper) {
    const zoomGallery = wrapper.querySelector('[data-zoom-gallery]');
    const zoomImages = wrapper.querySelectorAll('[data-zoom-image]');
    const zoomThumbnails = wrapper.querySelectorAll('[data-zoom-thumb]');

    if (!zoomGallery || zoomImages.length === 0) return;

    teardownScrollObserver();

    scrollObserver = new IntersectionObserver(
      entries => {
        let best = null;
        let bestRatio = 0;
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= bestRatio) {
            bestRatio = entry.intersectionRatio;
            best = entry.target;
          }
        });
        if (best && bestRatio >= 0.2) {
          setZoomVisibleSlide(zoomImages, zoomThumbnails, best.dataset.mediaId);
        }
      },
      {
        root: zoomGallery,
        threshold: [0, 0.1, 0.2, 0.35, 0.5, 0.65, 0.8, 1]
      }
    );

    zoomImages.forEach(img => scrollObserver.observe(img));
  }

  function teardownScrollObserver() {
    if (scrollObserver) {
      scrollObserver.disconnect();
      scrollObserver = null;
    }
  }

  function init() {
    const productWrapper = document.querySelector('.Product--redesign');
    if (!productWrapper) return;

    const gallery = productWrapper.querySelector('.Product__Gallery');
    const zoomContainer = productWrapper.querySelector('[data-zoom-container]');
    const zoomCloseBtn = productWrapper.querySelector('[data-zoom-out]');
    const zoomCloseBtn2 = productWrapper.querySelector('[data-zoom-close]');
    const zoomThumbnails = productWrapper.querySelectorAll('[data-zoom-thumb]');
    const zoomGallery = productWrapper.querySelector('[data-zoom-gallery]');
    const slideItems = productWrapper.querySelectorAll(
      '.Product__SlideItem--image, .Product__SlideItem[data-media-type="video"]'
    );

    if (!gallery || !zoomContainer) return;

    setupPinchZoom(productWrapper);

    slideItems.forEach(item => {
      item.addEventListener('click', () => {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
          // Don't close if user was pinching/panning
          if (pinch.didInteract) {
            pinch.didInteract = false;
            return;
          }
          if (isZoomActive) {
            closeZoom(productWrapper);
          } else {
            openZoomMobile(productWrapper);
          }
          return;
        }

        if (isZoomActive) {
          closeZoom(productWrapper);
        } else {
          const mediaId = item.dataset.mediaId;
          openZoomDesktop(productWrapper, mediaId);
        }
      });
    });

    zoomThumbnails.forEach(thumb => {
      thumb.addEventListener('click', e => {
        e.stopPropagation();
        if (window.innerWidth < DESKTOP_BREAKPOINT) return;

        const mediaId = thumb.dataset.mediaId;
        const targetImage = zoomGallery.querySelector(
          '[data-zoom-image][data-media-id="' + mediaId + '"]'
        );
        const allZoomImages = productWrapper.querySelectorAll('[data-zoom-image]');
        const thumbs = productWrapper.querySelectorAll('[data-zoom-thumb]');

        if (targetImage && zoomGallery && allZoomImages.length) {
          setZoomVisibleSlide(allZoomImages, thumbs, mediaId);
          requestAnimationFrame(() => {
            scrollZoomGalleryToImage(zoomGallery, targetImage);
          });
        }
      });
    });

    [zoomCloseBtn, zoomCloseBtn2].forEach(btn => {
      if (btn) {
        btn.addEventListener('click', e => {
          e.stopPropagation();
          closeZoom(productWrapper);
        });
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && isZoomActive) {
        closeZoom(productWrapper);
      }
    });

    document.addEventListener('click', e => {
      if (!isZoomActive || window.innerWidth < DESKTOP_BREAKPOINT) return;

      if (e.target.closest('[data-zoom-thumb]')) return;
      if (
        e.target.closest('[data-zoom-out]') ||
        e.target.closest('[data-zoom-close]') ||
        e.target.closest('.zoom-close')
      ) {
        return;
      }

      const clickedSlide = e.target.closest(
        '.Product__SlideItem--image, .Product__SlideItem[data-media-type="video"]'
      );
      if (clickedSlide) return;

      closeZoom(productWrapper);
    });
  }

  function openZoomDesktop(wrapper, mediaId) {
    if (isZoomActive) return;
    isZoomActive = true;
    savedScrollY = window.scrollY;

    window.scrollTo(0, 0);
    wrapper.classList.add(ZOOM_ACTIVE_CLASS);
    document.documentElement.classList.add('zoom-active');

    const zoomImages = wrapper.querySelectorAll('[data-zoom-image] img');
    zoomImages.forEach(img => {
      if (img.dataset.fullSrc) {
        img.src = img.dataset.fullSrc;
      }
    });

    const zoomGallery = wrapper.querySelector('[data-zoom-gallery]');
    const zoomThumbnails = wrapper.querySelectorAll('[data-zoom-thumb]');
    const allZoomImages = wrapper.querySelectorAll('[data-zoom-image]');

    if (mediaId && zoomGallery) {
      const targetImage = zoomGallery.querySelector(
        '[data-zoom-image][data-media-id="' + mediaId + '"]'
      );
      if (targetImage) {
        setZoomVisibleSlide(allZoomImages, zoomThumbnails, mediaId);
        requestAnimationFrame(() => {
          scrollZoomGalleryToImage(zoomGallery, targetImage);
        });
      } else if (allZoomImages.length && zoomThumbnails.length) {
        const firstId = zoomThumbnails[0].dataset.mediaId;
        setZoomVisibleSlide(allZoomImages, zoomThumbnails, firstId);
      }
    } else if (allZoomImages.length && zoomThumbnails.length) {
      const firstId = zoomThumbnails[0].dataset.mediaId;
      setZoomVisibleSlide(allZoomImages, zoomThumbnails, firstId);
    }

    requestAnimationFrame(() => {
      setupScrollObserver(wrapper);
    });
  }

  function openZoomMobile(wrapper) {
    if (isZoomActive) return;
    isZoomActive = true;
    savedScrollY = window.scrollY;

    window.scrollTo(0, 0);
    wrapper.classList.add(ZOOM_ACTIVE_CLASS);
    document.documentElement.classList.add('zoom-active');

    const gallery = wrapper.querySelector('.Product__Gallery');
    const galleryScroll =
      gallery && (gallery.querySelector('[data-gallery-scroll]') || gallery);
    if (galleryScroll) {
      galleryScroll.scrollTop = 0;
    }

    const images = wrapper.querySelectorAll('.Product__SlideItem--image img');
    images.forEach(img => {
      const currentSrc = img.src;
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = currentSrc;
      }
      img.src = currentSrc.replace(/_\d+x\./, '.');
    });
  }

  function closeZoom(wrapper) {
    if (!isZoomActive) return;
    isZoomActive = false;

    teardownScrollObserver();
    resetAllPinchZoom(wrapper);

    wrapper.classList.remove(ZOOM_ACTIVE_CLASS);
    document.documentElement.classList.remove('zoom-active');
    document.documentElement.style.top = '';

    window.scrollTo(0, savedScrollY);

    const images = wrapper.querySelectorAll('.Product__SlideItem--image img');
    images.forEach(img => {
      if (img.dataset.originalSrc) {
        img.src = img.dataset.originalSrc;
      }
    });

    wrapper.querySelectorAll('[data-zoom-image]').forEach(el => {
      el.classList.remove('is-zoom-visible');
    });

    wrapper.querySelectorAll('[data-zoom-container] video[data-pdp-video]').forEach(v => {
      v.pause();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
